import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {OccupationalProfile} from '../shared/occupational-profile';
import {DomSanitizer, SafeUrl, Title} from '@angular/platform-browser';
import {Config} from '../shared/orientationtest-config/config';

@Component({
    selector: 'occupational-profile-base-info',
    templateUrl: './occupational-profile-base-info.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileBaseInfoComponent implements OnInit, OnDestroy {
	@Input()
	public config!: Config;
    @Input()
    public occupationalProfile!: OccupationalProfile;
    public showTablet = true;
    public showComputer = true;

    private previousTitle?: string;

    public constructor(
        private readonly title: Title,
        private readonly sanitizer: DomSanitizer
    ) { }

    ngOnDestroy(): void {
        if(this.previousTitle) {
            this.title.setTitle(this.previousTitle);
        }
    }

    ngOnInit(): void {
        this.previousTitle = this.title.getTitle();
        if(this.occupationalProfile.title?.nl) {
            this.title.setTitle(`${this.occupationalProfile.title.nl} | VDAB`);
        }
    }

    getComputerPhoto(): string | null {
        const photoUrl = this.getPhoto();
        return photoUrl ? photoUrl.replace('${orientatie}', 'v') : null;
    }

    getTabletPhoto(): string | null {
        const photoUrl = this.getPhoto();
        return photoUrl ? photoUrl.replace('${orientatie}', 'h') : null;
    }

    getSanitizedUrl(url: string): SafeUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    getPhoto(): string | null {
        const photo = this.occupationalProfile.vdabSpecific.externalReferences
            .filter(externalReference => 'PHOTO' === externalReference.type)
            .pop();
        return photo ? photo.url : null;
    }

    public hideImageAndFooterComputer(): void {
        this.showComputer = false;
    }

    public hideImageAndFooterTablet(): void {
        this.showTablet = false;
    }

}
